import request from "@/utils/interceptor.js";

const uploadApi = {
    // 上传人脸文件
  personnelUploadFile(data) {
    return request({
      url: `/api/pas/tester-evaluation-face/upload-image-analysis`,
      method: "post",
      data,
    });
  },
  //查人脸照片
  getFileData(id) {
    return request({
      url: `/api/pas/file-data/${id}`,
      method: "get",
    });
  },
    testerEvaluationFace(params) {
    return request({
      url: `/api/pas/tester-evaluation-face`,
      method: "get",
      params,
    });
  },
  // 上传文件
  UploadFile(data) {
    return request({
      url: `/api/pas/file-data/upload-file`,
      method: "post",
      data,
    });
  },
  // 上传文件（pId）
  UploadFilePid(data,pId) {
    return request({
      url: `/api/pas/file-data/upload-file-pid/${pId}`,
      method: "post",
      data,
    });
  },
  // 获取文件列表
  getFileList(pId) {
    return request({
      url: `/api/pas/file-data`,
      method: "get",
      params: {
        pId,
        SkipCount: 0,
        MaxResultCount: 1000,
      },
    });
  },
  //删除文件
  DeleteFile(id) {
    return request({
      url: `/api/pas/file-data/${id}/file-id`,
      method: "delete",
    });
  },
  //下载模板
  downloadTemp(organizationId) {
    return request({
      url: `/api/pas/tester/template-download/${organizationId}`,
      method: "post",
    });
  },
  //导入模板
  importTemp(organizationId,data) {
    return request({
      url: `/api/pas/tester/upload-excel-file/${organizationId}`,
      method: "post",
      data,
    });
  },
  //海康模板导入
  HikvisionImportTemp(data) {
    return request({
      url: `/api/app/hikvision-tester-face/upload-excel-file`,
      method: "post",
      data,
    });
  },
    //海康人脸上传
  uploadSingleFace(data) {
    return request({
      url: `/api/app/hikvision-tester-face/upload-single-face`,
      method: "post",
      data,
    });
  },
};

export default uploadApi;
